import React from "react";
import { translateColorToHex } from "../utility";

const SectionHeaderPill = ({ data }) => {

  let sectionPillItems = data.items;

  const pillBackground = {
    backgroundColor: translateColorToHex(data.primary.section_header_background_color),
  }

  return (
    <React.Fragment>
      <div className="sectionHeader">
        <h6 className="sectionTitle" style={pillBackground}>{data.primary.section_header_text.text}</h6>
      </div>
    </React.Fragment>
  )

}

export default SectionHeaderPill;